import { InjectionToken } from '@angular/core';
import { ContentDictionaryMapping } from '../models/content-dictionary-mapping.type';

export const CONTENT_DICTIONARY_MAPPING = new InjectionToken<
  ContentDictionaryMapping | ContentDictionaryMapping[]
>('Content dictionary mapping token');
